<section class="bf-hero">

  <div
    class="bf-hero__parallax-host"
    data-parallax-host
  >

    <div
      class="bf-hero__parallax-item"
      bfParallax
      data-parallax-item
    >

      <figure
        class="bf-hero__image-wrapper"
        data-parallax-image-wrapper
      >

        <img
          [src]="imageSrc"
          [alt]="imageAlt"
          class="bf-hero__image"
        />

      </figure>

    </div>

  </div>


  <div class="bf-hero__content">

    <div class="bf-hero__rule"></div>

    <div class="bf-hero__logo">

      <div class="bulls-barber-container">
        <a routerLink="/">
          <img
            src="/images/bonefade-source/bulls-white-logo.png"
            alt="Bonefade Barbers"
          />
        </a>
      </div>

    </div>

    <app-social-links class="bf-hero__tablet-social"></app-social-links>

    <button
      type="button"
      class="bf-button bf-hero__mobile-button"
      (click)="toast.show('Coming soon')"
    >
      Időpontfoglalás
    </button>

    <nav class="bf-hero__mobile-nav">
      @for (link of navLinks; track link.label) {
        @if (link.sectionId) {
          <a
            [href]="link.path + '#' + link.sectionId"
            [appScrollToSection]="link.sectionId"
            [scrollBelowBreakpoint]="link.breakpoint"
            [routeTarget]="link.path"
            [global]="link.global ?? false"
          >{{ link.label }}</a>
        } @else {
          <a [routerLink]="link.path">{{ link.label }}</a>
        }
      }
    </nav>

    <div class="bf-hero__rule"></div>

  </div>

  <app-social-links class="bf-hero__mobile-social"></app-social-links>

</section>
